import { Link } from 'react-router-dom';
import { PortalShell } from '@/layouts/PortalShell/PortalShell';
import { FooterChrome } from '@/layouts/FooterChrome/FooterChrome';
import { nb } from '@/i18n/nb';
import s from '@/views/Personvern/Personvern.module.css';

// Stub destination for the footer's Kontakt link (reuses the Personvern stub styling).
export function Kontakt() {
  return (
    <PortalShell>
      <main className={s.page}>
        <h1 className={s.heading}>{nb.kontakt.heading}</h1>
        <p className={s.body}>{nb.kontakt.body}</p>
        <Link to="/" className={s.backLink}>
          {nb.kontakt.backToFront}
        </Link>
      </main>
      <FooterChrome />
    </PortalShell>
  );
}
